import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_update_ua_report",
  ref: "updateUaReportModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_update_ua_report_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  id: "kt_modal_update_ua_report_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_update_ua_report_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_update_ua_report_header",
  "data-kt-scroll-wrappers": "#kt_modal_update_ua_report_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "d-flex flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-60px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6 required" }, "Period")
    ])
  ])
], -1)
const _hoisted_12 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_13 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_14 = { class: "d-flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-40px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6" }, "Queue as Job")
    ])
  ])
], -1)
const _hoisted_16 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_17 = { class: "d-flex flex-row h-40px w-200px" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex flex-row h-40px w-200px"
}
const _hoisted_19 = { class: "d-flex flex-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-row-auto w-200px" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column-auto h-60px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" })
  ])
], -1)
const _hoisted_21 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_22 = { class: "d-flex flex-column-auto h-40px" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "modal-footer flex-center" }
const _hoisted_25 = ["data-kt-indicator"]
const _hoisted_26 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_28 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_29 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, "Update UA Report: " + _toDisplayString(_ctx.uaproject.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.dates,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dates) = $event)),
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "Start date",
                        "end-placeholder": "End date",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.job,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.job) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booleanSelect, (option) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: option.id,
                              label: option.name,
                              value: option.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (_ctx.formData.job)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_el_form_item, { prop: "job_name" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.job_name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.job_name) = $event)),
                                type: "text",
                                placeholder: "Job Name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", {
                        href: _ctx.uaproject.spreadsheet,
                        target: "_blank"
                      }, "View Spreadsheet", 8, _hoisted_23)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_32))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_25)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}